import { render, staticRenderFns } from "./LiveAddSponsorForm.vue?vue&type=template&id=31ba9ba4"
import script from "./LiveAddSponsorForm.vue?vue&type=script&lang=js"
export * from "./LiveAddSponsorForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports